module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('button', {
    staticClass: "senas-video",
    attrs: {
      "tabindex": "-1",
      "aria-label": _vm.videoShow && _vm.active ? 'Cerrar' : 'Abrir' + ' video en lenguaje de señas',
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clickBot($event)
      }
    }
  }, [_c('div', {
    staticClass: "acces-icon back-red hvr-grow"
  }, [_c('v-icon', {
    staticClass: "always-white"
  }, [_vm._v("fa fa-sign-language")])], 1), _vm._v(" "), _c('div', {
    staticClass: "acces-bot-name back-red animated fadeIn"
  }, [_c('p', {
    staticClass: "always-white"
  }, [_vm._v(_vm._s(_vm.videoShow && _vm.active ? 'Ocultar' : 'Ver') + " video en LSC")])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80vw",
      "max-width": "700",
      "role": "dialog"
    },
    model: {
      value: (_vm.videoShow),
      callback: function($$v) {
        _vm.videoShow = $$v
      },
      expression: "videoShow"
    }
  }, [_c('v-card', {
    staticClass: "pt-4 pb-4 pl-4 pr-4 align-center"
  }, [(_vm.videoShow && _vm.active) ? _c('v-flex', {
    staticClass: "animated fadeIn",
    attrs: {
      "xs12": ""
    }
  }, [_c('video-app', {
    attrs: {
      "videoSize": 600,
      "vidTittle": _vm.vidTittle,
      "videoEmbed": _vm.videoEmbed,
      "youtubeEmbed": _vm.youtubeEmbed
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('ui-button', {
    attrs: {
      "primary": "",
      "content": "Cerrar contenido",
      "aria": "Cerrar contenido"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleVideo()
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-685c13e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ui-lsc-dialog.vue
// module id = 1034
// module chunks = 1